/**
 * 指定した基準日（判定日）時点での満年齢を計算する
 */
export function calculateAge(
  対象年: number,
  対象月: number,
  対象日: number,
  生年月日_年: number,
  生年月日_月: number,
  生年月日_日: number,
): number {
  // 1. 単純な「年」の引き算
  let age = 対象年 - 生年月日_年;

  // 2. まだ今年の誕生日（またはその前日）を迎えていない場合の補正
  // 誕生月の比較
  if (対象月 < 生年月日_月) {
    age--;
  } 
  // 誕生月だが、日がまだ誕生日の前日に達していない場合
  else if (対象月 === 生年月日_月 && 対象日 < 生年月日_日 - 1) {
    age--;
  }

  return age;
}